var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "annotation-form" },
    [
      _vm.isLoading || _vm.isSavingComment
        ? [
            _c("CompassSkeleton", { attrs: { variant: "square" } }),
            _vm._v(" "),
            _c("CompassSkeleton", { attrs: { variant: "block" } })
          ]
        : [
            _c("CompassObject", {
              attrs: { object: "comment", size: "small" }
            }),
            _vm._v(" "),
            _c(
              "el-form",
              {
                ref: "annotationForm",
                attrs: {
                  model: _vm.annotation,
                  labelPosition: "top",
                  inline: true,
                  inlineMessage: true
                }
              },
              [
                _vm.showHint
                  ? _c("div", {
                      staticClass:
                        "annotation-form__ai-hint typographies-paragraph-small-regular",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t.__("richtext.ai.hint"))
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("RichText", {
                  staticClass: "annotation-richtext",
                  attrs: {
                    placeholder: _vm.$t.__(
                      "forms.AnnotationForm.write_comment_or_mention_someone"
                    ),
                    options: _vm.optionsRichText,
                    typeRichText: "comment",
                    useStorage: true,
                    refRichText: _vm.refRichText,
                    showAIComponents: _vm.showAIComponents,
                    hash: _vm.hash
                  },
                  on: {
                    focus: function($event) {
                      _vm.isEditorFocused = true
                    },
                    blur: function($event) {
                      _vm.isEditorFocused = false
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      _vm.timetrackingEnabled
                        ? {
                            key: "more-custom-options",
                            fn: function() {
                              return [
                                _c("TimetrackingRichText", {
                                  attrs: {
                                    showMenuTimetracking:
                                      _vm.showMenuTimetracking,
                                    mode: _vm.mode,
                                    defaultOptions: _vm.defaultOptions,
                                    refRichText: _vm.refRichText
                                  },
                                  model: {
                                    value: _vm.annotation.timetracking,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.annotation,
                                        "timetracking",
                                        $$v
                                      )
                                    },
                                    expression: "annotation.timetracking"
                                  }
                                })
                              ]
                            },
                            proxy: true
                          }
                        : null,
                      _vm.canSaveAnnotation && !_vm.isSavingComment
                        ? {
                            key: "actions",
                            fn: function() {
                              return [
                                _c("CompassButton", {
                                  attrs: {
                                    label: _vm.$t.__("common.actions.cancel"),
                                    type: "secondary",
                                    size: "small"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.resetAnnot($event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("CompassButton", {
                                  attrs: {
                                    label: _vm.$t.__("common.actions.save"),
                                    size: "small"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.submitForm("annotationForm")
                                    }
                                  }
                                })
                              ]
                            },
                            proxy: true
                          }
                        : null
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.annotation.description,
                    callback: function($$v) {
                      _vm.$set(_vm.annotation, "description", $$v)
                    },
                    expression: "annotation.description"
                  }
                })
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }